import { client } from '../../../../../actions';
import { authHeader } from '../../../../../helpers/auth-header';

export const createAdminInfoField = async ({ companyId, requestBody }) => {
  const url = `/Admin/company/${companyId}/item`;

  const response = await client.post(url, requestBody, {
    headers: authHeader(),
  });

  return response.data;
};
